// Indian Languages - Grouped for easier access
export const indianLanguages = [
    { value: 'hindi', label: 'Hindi', native: 'हिन्दी', region: 'india' },
    { value: 'bengali', label: 'Bengali', native: 'বাংলা', region: 'india' },
    { value: 'telugu', label: 'Telugu', native: 'తెలుగు', region: 'india' },
    { value: 'marathi', label: 'Marathi', native: 'मराठी', region: 'india' },
    { value: 'tamil', label: 'Tamil', native: 'தமிழ்', region: 'india' },
    { value: 'gujarati', label: 'Gujarati', native: 'ગુજરાતી', region: 'india' },
    { value: 'urdu', label: 'Urdu', native: 'اردو', region: 'india' },
    { value: 'kannada', label: 'Kannada', native: 'ಕನ್ನಡ', region: 'india' },
    { value: 'odia', label: 'Odia', native: 'ଓଡ଼ିଆ', region: 'india' },
    { value: 'malayalam', label: 'Malayalam', native: 'മലയാളം', region: 'india' },
    { value: 'punjabi', label: 'Punjabi', native: 'ਪੰਜਾਬੀ', region: 'india' },
    { value: 'assamese', label: 'Assamese', native: 'অসমীয়া', region: 'india' },
    { value: 'maithili', label: 'Maithili', native: 'मैथिली', region: 'india' },
    { value: 'santali', label: 'Santali', native: 'ᱥᱟᱱᱛᱟᱲᱤ', region: 'india' },
    { value: 'kashmiri', label: 'Kashmiri', native: 'कॉशुर', region: 'india' },
    { value: 'nepali', label: 'Nepali', native: 'नेपाली', region: 'india' },
    { value: 'sindhi', label: 'Sindhi', native: 'سنڌي', region: 'india' },
    { value: 'konkani', label: 'Konkani', native: 'कोंकणी', region: 'india' },
    { value: 'dogri', label: 'Dogri', native: 'डोगरी', region: 'india' },
    { value: 'manipuri', label: 'Manipuri', native: 'মৈতৈলোন্', region: 'india' },
    { value: 'bodo', label: 'Bodo', native: 'बड़ो', region: 'india' },
    { value: 'sanskrit', label: 'Sanskrit', native: 'संस्कृतम्', region: 'india' },
    { value: 'bhojpuri', label: 'Bhojpuri', native: 'भोजपुरी', region: 'india' },
    { value: 'rajasthani', label: 'Rajasthani', native: 'राजस्थानी', region: 'india' },
    { value: 'chhattisgarhi', label: 'Chhattisgarhi', native: 'छत्तीसगढ़ी', region: 'india' },
    { value: 'haryanvi', label: 'Haryanvi', native: 'हरियाणवी', region: 'india' },
    { value: 'marwari', label: 'Marwari', native: 'मारवाड़ी', region: 'india' },
    { value: 'magahi', label: 'Magahi', native: 'मगही', region: 'india' },
    { value: 'awadhi', label: 'Awadhi', native: 'अवधी', region: 'india' },
    { value: 'tulu', label: 'Tulu', native: 'ತುಳು', region: 'india' }
];

// Global Languages - Major world languages
export const globalLanguages = [
    { value: 'english', label: 'English', native: 'English', region: 'global' },
    { value: 'mandarin', label: 'Mandarin Chinese', native: '普通话', region: 'global' },
    { value: 'spanish', label: 'Spanish', native: 'Español', region: 'global' },
    { value: 'french', label: 'French', native: 'Français', region: 'global' },
    { value: 'arabic', label: 'Arabic', native: 'العربية', region: 'global' },
    { value: 'portuguese', label: 'Portuguese', native: 'Português', region: 'global' },
    { value: 'russian', label: 'Russian', native: 'Русский', region: 'global' },
    { value: 'japanese', label: 'Japanese', native: '日本語', region: 'global' },
    { value: 'german', label: 'German', native: 'Deutsch', region: 'global' },
    { value: 'korean', label: 'Korean', native: '한국어', region: 'global' },
    { value: 'italian', label: 'Italian', native: 'Italiano', region: 'global' },
    { value: 'dutch', label: 'Dutch', native: 'Nederlands', region: 'global' },
    { value: 'turkish', label: 'Turkish', native: 'Türkçe', region: 'global' },
    { value: 'polish', label: 'Polish', native: 'Polski', region: 'global' },
    { value: 'vietnamese', label: 'Vietnamese', native: 'Tiếng Việt', region: 'global' },
    { value: 'thai', label: 'Thai', native: 'ภาษาไทย', region: 'global' },
    { value: 'indonesian', label: 'Indonesian', native: 'Bahasa Indonesia', region: 'global' },
    { value: 'malay', label: 'Malay', native: 'Bahasa Melayu', region: 'global' },
    { value: 'greek', label: 'Greek', native: 'Ελληνικά', region: 'global' },
    { value: 'hebrew', label: 'Hebrew', native: 'עברית', region: 'global' },
    { value: 'persian', label: 'Persian (Farsi)', native: 'فارسی', region: 'global' },
    { value: 'swedish', label: 'Swedish', native: 'Svenska', region: 'global' },
    { value: 'norwegian', label: 'Norwegian', native: 'Norsk', region: 'global' },
    { value: 'danish', label: 'Danish', native: 'Dansk', region: 'global' },
    { value: 'finnish', label: 'Finnish', native: 'Suomi', region: 'global' },
    { value: 'czech', label: 'Czech', native: 'Čeština', region: 'global' },
    { value: 'hungarian', label: 'Hungarian', native: 'Magyar', region: 'global' },
    { value: 'romanian', label: 'Romanian', native: 'Română', region: 'global' },
    { value: 'ukrainian', label: 'Ukrainian', native: 'Українська', region: 'global' },
    { value: 'swahili', label: 'Swahili', native: 'Kiswahili', region: 'global' },
    { value: 'tagalog', label: 'Tagalog (Filipino)', native: 'Tagalog', region: 'global' },
    { value: 'burmese', label: 'Burmese', native: 'မြန်မာဘာသာ', region: 'global' },
    { value: 'khmer', label: 'Khmer', native: 'ខ្មែរ', region: 'global' },
    { value: 'sinhala', label: 'Sinhala', native: 'සිංහල', region: 'global' },
    { value: 'afrikaans', label: 'Afrikaans', native: 'Afrikaans', region: 'global' },
    { value: 'catalan', label: 'Catalan', native: 'Català', region: 'global' },
    { value: 'serbian', label: 'Serbian', native: 'Српски', region: 'global' },
    { value: 'croatian', label: 'Croatian', native: 'Hrvatski', region: 'global' },
    { value: 'slovak', label: 'Slovak', native: 'Slovenčina', region: 'global' },
    { value: 'bulgarian', label: 'Bulgarian', native: 'Български', region: 'global' }
];

// Combined list for searchable dropdown
export const allLanguages = [
    { value: '__indian_header__', label: '── Indian Languages ──', isHeader: true },
    ...indianLanguages,
    { value: '__global_header__', label: '── Global Languages ──', isHeader: true },
    ...globalLanguages
];

// Get language label by value
export const getLanguageLabel = (value) => {
    const lang = [...indianLanguages, ...globalLanguages].find(l => l.value === value);
    return lang ? lang.label : value;
};

// Get language with native name
export const getLanguageWithNative = (value) => {
    const lang = [...indianLanguages, ...globalLanguages].find(l => l.value === value);
    return lang ? `${lang.label} (${lang.native})` : value;
};

export default allLanguages;
